import React from 'react';

const Education = () => {
  return (
    <div className="page">
      <h1>Education Solutions</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Education; 